var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex p-1 items-center menu_item"},[_c('a',{staticClass:"button is-white p-1 w-full flex justify-start",style:(_vm.itemColorStyle),on:{"click":_vm.onClickHandler}},[_c('img',{staticClass:"img-icon pr-2",attrs:{"src":_vm.srcIcon}}),_vm._v(" "+_vm._s(_vm.textOption)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }